import DashboardLayout from "../../../shared/DashboardLayout";

const AddEditCaExpenses = () => {
  return (
    <DashboardLayout>
      <h2 className="m-4">New CA Expense</h2>
      <div className="row m-4">
        <div className="col-lg-4">
          <label for="expense_amount" className="form-label fw-bolder">
            Amount
            <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="number"
            className="form-control"
            name="expense_amount"
            id="expense_amount"
            value=""
            required
          />
        </div>
        <div className="col-lg-4">
          <label for="expense_date" className="form-label fw-bolder">
            Paid Date
            <span className="required">*</span>
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="date"
            className="form-control"
            name="expense_date"
            id="expense_date"
            value=""
            required
          />
        </div>
        <div className="col-lg-4">
          <label
            for="expense_payment_description"
            className="form-label fw-bolder"
          >
            Payment Description
          </label>
        </div>
        <div className="col-lg-8 form-group">
          <input
            type="text"
            className="form-control"
            name="expense_payment_description"
            id="expense_payment_description"
            value=""
          />
        </div>
        <div className="col-lg-4">
          <button
            className="btn site_btn text-white"
            name="submit"
            type="submit"
          >
            Add CA Expense
          </button>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddEditCaExpenses;
